export const strings = {
    prefixAgo: 'пред',
    prefixFromNow: 'за',
    suffixAgo: null,
    suffixFromNow: null,
    seconds: '%d секунди',
    minute: '%d минута',
    minutes: '%d минути',
    hour: '%d час',
    hours: '%d часа',
    day: '%d ден',
    days: '%d денови',
    month: '%d месец',
    months: '%d месеци',
    year: '%d година',
    years: '%d години',
};
